import { render } from "./AuthentcateForm.vue?vue&type=template&id=06a9c950&ts=true"
import script from "./AuthentcateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthentcateForm.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/login/AuthentcateForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06a9c950"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06a9c950', __exports__)) {
    console.log('reload')
    api.reload('06a9c950', __exports__)
  }
  
  module.hot.accept("./AuthentcateForm.vue?vue&type=template&id=06a9c950&ts=true", () => {
    console.log('re-render')
    api.rerender('06a9c950', render)
  })

}


export default __exports__